







































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CashflowV2 from '@/charts/CashFlow_v2.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';

@Component({
  components: {
    CashflowV2,
    DynamicColumnChart,
    DynamicLineChart,
    ValuationAnalysis,
  },
})

export default class ValuationAnalysis extends Vue {
  @Prop() readonly doc!: any;

  isActive(section: any) {
    const years = this.doc.profitloss.count - 1;
    switch (section) {
      case 'hasnot12months':
        for (let i = 0; i <= years; i++) {
          if (this.doc.profitloss.sheets[i].MONTHS !== '12') {
            return true;
          }
        }
        return false;
      case 'hasnoturnover':
        for (let i = 0; i <= years; i++) {
          if (this.doc.profitloss.sheets[i].A === 0) {
            return true;
          }
        }
        return false;
    }
  }

  minValue(kr: any) {
    const years = this.doc.profitloss.count;
    let values: any[] = [];
    switch (kr) {
      case 'growth':
        for (let i = 0; i + 1 < years; i++) {
          // tslint:disable:max-line-length
          const val = ((this.doc.profitloss.sheets[i].A * (12 / this.doc.profitloss.sheets[i].MONTHS))  / (this.doc.profitloss.sheets[i + 1].A * (12 / this.doc.profitloss.sheets[i + 1].MONTHS))) - 1;
          values = values.concat(val);
        }
        const growth = Math.min(...values);
        return growth;
      case 'operatingCashflowPercent':
        for (let i = 0; i + 1 < years; i++) {
          const val = (this.doc.cashflow.sheets[i].OperatingCashflow / this.doc.profitloss.sheets[i].A);
          values = values.concat(val);
        }
        const operatingCashflowPercent = Math.min(...values);
        return operatingCashflowPercent;
    }
  }

  maxValue(kr: any) {
    const years = this.doc.profitloss.count;
    let values: any[] = [];
    switch (kr) {
      case 'growth':
        for (let i = 0; i + 1 < years; i++) {
          // tslint:disable:max-line-length
          const val = ((this.doc.profitloss.sheets[i].A * (12 / this.doc.profitloss.sheets[i].MONTHS))  / (this.doc.profitloss.sheets[i + 1].A * (12 / this.doc.profitloss.sheets[i + 1].MONTHS))) - 1;
          values = values.concat(val);
        }
        const growth = Math.max(...values);
        return growth;
      case 'operatingCashflowPercent':
        for (let i = 0; i + 1 < years; i++) {
          const val = (this.doc.cashflow.sheets[i].OperatingCashflow / this.doc.profitloss.sheets[i].A);
          values = values.concat(val);
        }
        const operatingCashflowPercent = Math.max(...values);
        return operatingCashflowPercent;
    }
  }

  totalValue(kr: any) {
    const years = this.doc.profitloss.count;
    let total = 0;
    switch (kr) {
      case 'growth':
        for (let i = 0; i + 1 < years; i++) {
          // tslint:disable:max-line-length
          const val = ((this.doc.profitloss.sheets[i].A * ( 12 / this.doc.profitloss.sheets[i].MONTHS )) / (this.doc.profitloss.sheets[i + 1].A)  * ( 12 / this.doc.profitloss.sheets[i + 1].MONTHS ) ) - 1;
          total = total + val;
        }
        return total;
      case 'operatingCashflowPercent':
        for (let i = 0; i + 1 < years; i++) {
          const val = (this.doc.cashflow.sheets[i].OperatingCashflow / this.doc.profitloss.sheets[i].A);
          total = total + val;
        }
        return total;
    }
  }


  thisVersion() {
  if (process.env.VUE_APP_BRAND === 'GT') {
    return 'gt';
  }
  }
}
